<style>

.input{
  display: grid;
  grid-template-columns: 55px 15px;
}
.month{
  grid-column: 1;
}
.arrow{
  grid-column: 2;
}


.sel{
  border: 1px rgba(0,0,0,1) solid;
  background-color: rgba(0,0,0,0.7);
  color: white;
}

.hide{
  display: none;
}

</style>

<div class="input">
  <div class="month">{month == 'MM' || month == -1 ? 'MM' : months[month-1]}</div>
  <div class="arrow"><i class="icon-keyboard_arrow_down"></i></div>
</div>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let month = "MM";
export let year = "YYYY";

let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

</script>